var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Instructional',{staticClass:"px-1",attrs:{"egress_profile_matter_id":_vm.egress_profile_matter_id,"highlight_activity_id":_vm.highlight_activity_id,"allows_crud":_vm.allows_crud,"can_delete":_vm.can_delete,"can_update":_vm.can_update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }